import { ApiInstance } from '../..';
import { SearchQueryParams } from '../../../interface/paging';
import { TMaintenanceService } from '../../../pages/start-work-order/type';
import { convert2QueryString } from '../../../utils/convert2QueryString';

export const getMaintenanceServicePaging = (
    params: SearchQueryParams | undefined
) => {
    const requestURL =
        '/api/maintenance-services/search?' + convert2QueryString(params ?? {});
    return ApiInstance.getInstance().get(requestURL);
};

export const createMaintenanceService = (data: any) => {
    return ApiInstance.getInstance().post(
        '/api/maintenance-services/add',
        data
    );
};

export const updateMaintenanceService = (
    serviceId: string | undefined | number,
    data: TMaintenanceService
) => {
    const baseUrl = `/api/maintenance-services/${serviceId}`;
    return ApiInstance.getInstance().put(baseUrl, data);
};

export const deleteMaintenanceService = (
    serviceId: string | undefined | number
) => {
    const baseUrl = `/api/maintenance-services/${serviceId}`;
    return ApiInstance.getInstance().delete(baseUrl);
};

export const seedDefaultMaintenanceServices = () => {
    return ApiInstance.getInstance().post('/api/maintenance-services/seed');
};
